import { useState } from "react";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useDeleteMasterDataPdfMutation } from "@/services/backend/company/api/master-data-pdf";
import { MasterDataPdfDefault } from "@/services/backend/company/types/master-data-pdf";

export function MasterDataPdfDeleteDialog({
  masterData,
}: {
  masterData: MasterDataPdfDefault;
}) {
  const [open, setOpen] = useState(false);
  const [deleteMasterData, { isLoading, error, isSuccess, reset }] =
    useDeleteMasterDataPdfMutation();

  if (isSuccess) {
    setOpen(false);
    reset();
  }

  const onClick = () => {
    if (isLoading) {
      return;
    }
    deleteMasterData({ id: masterData.id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm">
          <Trash2 className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("PDF-Template-Daten löschen")}</DialogTitle>
        </DialogHeader>
        <div>
          {t("Sollen die PDF-Template-Daten ") +
            masterData.label +
            t(" wirklich entfernt werden?")}
        </div>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onClick} disabled={isLoading}>
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
